import React from "react";
import BaseModal from "./BaseModal";
import NoteTagList from "../buttons/NoteTag";
import NoteTagFilter from "../forms/NoteTagFilter";
import { handleFilterDeletion } from "../../../utils/FilterDisplayUtils";

// return filters, filtertags, and sites

class FilterModal extends React.Component {
  constructor(props) {
    super(props);

    this.defaultFilters = {
      noteTags: [],
      tagAddedOnClose: null,
    };

    this.state = {
      ...this.defaultFilters,
      ...props.filters,
      showButtons: true,
    };
  }

  onClose = () => {
    this.props.handleOnClose(this.state);
  };

  readyFilterUpdate = (val) => {
    this.setState({ showButtons: false });
  };

  handleFilterUpdate = (filterType, val) => {
    switch (filterType) {
      case "noteTag":
        let { noteTags } = this.state;
        noteTags = [...noteTags, val];

        this.setState({ noteTags, tagAddedOnClose: null, showButtons: true });
        return;

      default:
        this.setState({ [filterType]: val });
    }
  };

  render() {
    return (
      <>
        <BaseModal
          title={this.props.title}
          open={true}
          onClose={() => {
            this.onClose();
          }}
          {...this.props}
        >
          <div className={"wrapper"} style={{ margin: "2em" }}>
            <form onSubmit={this.onClose}>
              <div
                className={"tag-list-wrapper"}
                style={{ margin: "0 0 2em 0" }}
              >
                <label>Filter by Tags</label>
                <NoteTagFilter
                  onSubmit={(res) => this.handleFilterUpdate("noteTag", res)}
                  onSelect={(res) => this.readyFilterUpdate(res)}
                  categories={this.props.categories}
                />
                <NoteTagList
                  notes={this.state.noteTags}
                  editable
                  onRemoveNote={(data) =>
                    this.setState({
                      noteTags: handleFilterDeletion(
                        "noteTag",
                        data,
                        this.state
                      ).noteTags,
                    })
                  }
                />
              </div>

              {this.state.showButtons && (
                <div className="button-wrapper">
                  <button className={"btn btn-primary"} onClick={this.onClose}>
                    OK
                  </button>
                  <div
                    className="button button-outline"
                    onClick={() => this.setState({ ...this.defaultFilters })}
                  >
                    Clear Filters
                  </div>
                </div>
              )}
            </form>
          </div>
        </BaseModal>
      </>
    );
  }
}

// const mapStateToProps = (state) => ({
//   sites: state.sites.data,
// });

// export default connect(mapStateToProps)(SiteFilter);

export default FilterModal;
